import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SiteContext } from "../context/SiteContext";
import { api } from "../services/api";
import "./PaginaEmpilhamento.css";

export default function PaginaEmpilhamento() {
  const { areaSlug, itemId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { config } = useContext(SiteContext);

  const [loading, setLoading] = useState(true);
  const [detalhesItem, setDetalhesItem] = useState(location.state?.item || null);
  const [pilhaArquivos, setPilhaArquivos] = useState([]);
  const [anoFiltro, setAnoFiltro] = useState("TODOS");
  const [busca, setBusca] = useState("");

  useEffect(() => {
    async function carregarPilha() {
      if (!config?.id || !areaSlug || !itemId) return;

      try {
        setLoading(true);
        const response = await api.get(
          `/area/${areaSlug}/item/${itemId}?cliente=${config.id}`
        );

        if (response.data) {
          if (!detalhesItem && response.data.item) {
            setDetalhesItem(response.data.item);
          }
          const docs = Array.isArray(response.data)
            ? response.data
            : response.data.arquivos || response.data.itens || [];
          setPilhaArquivos(docs);
        }
      } catch (error) {
        console.error("Erro ao buscar pilha de documentos:", error);
      } finally {
        setLoading(false);
      }
    }

    carregarPilha();
  }, [config?.id, areaSlug, itemId]);

  // Lista de anos para o filtro rápido
  const anosDisponiveis = [
    "TODOS",
    ...new Set(
      pilhaArquivos
        .map((arq) => arq.exercicio || arq.ano)
        .filter(Boolean)
        .sort((a, b) => b - a)
    ),
  ];

  const arquivosFiltrados = pilhaArquivos.filter((arq) => {
    const atendeAno =
      anoFiltro === "TODOS" || String(arq.exercicio || arq.ano) === String(anoFiltro);
    const termo = busca.toLowerCase();
    const atendeBusca =
      !busca ||
      (arq.titulo || arq.nome || "").toLowerCase().includes(termo) ||
      (arq.descricao || "").toLowerCase().includes(termo);

    return atendeAno && atendeBusca;
  });

  if (loading) {
    return (
      <div className="loader-container">
        <div className="hexagon-spinner"></div>
        <p className="loader-text">Carregando publicações...</p>
      </div>
    );
  }

  return (
    <div className="area-page-wrapper">
      {/* Cabeçalho no mesmo padrão da Área */}
      <header className="area-header">
        <div className="container">
          <div className="header-nav-container">
            <button className="btn-voltar-padrao" onClick={() => navigate(-1)}>
              ← Voltar para {location.state?.tituloArea || "a Área"}
            </button>
          </div>
          <h1 className="area-title">
            {detalhesItem?.nome || "Documentos Disponíveis"}
          </h1>
          {detalhesItem?.nota && (
            <p className="area-subtitle">{detalhesItem.nota}</p>
          )}
        </div>
      </header>

      {/* Conteúdo centralizado em 60% */}
      <div className="area-content">
        <div className="search-bar-container">
          <input
            type="text"
            className="search-input"
            placeholder="Buscar por descrição, número ou título..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />

          {anosDisponiveis.length > 2 && (
            <div className="anos-pills">
              {anosDisponiveis.map((ano) => (
                <button
                  key={ano}
                  type="button"
                  className={`pill-btn ${anoFiltro === ano ? "active" : ""}`}
                  onClick={() => setAnoFiltro(ano)}
                >
                  {ano}
                </button>
              ))}
            </div>
          )}
        </div>

        {arquivosFiltrados.length > 0 ? (
          <div className="documents-grid">
            {arquivosFiltrados.map((doc, idx) => {
              const temArquivo = Boolean(doc.link || doc.url);
              return (
                <div
                  key={doc.id || idx}
                  className={`document-card ${!temArquivo ? "indisponivel" : ""}`}
                >
                  <div className="doc-info">
                    <div className="stack-badges">
                      {(doc.exercicio || doc.ano) && (
                        <span className="badge-ano">
                          {doc.exercicio || doc.ano}
                        </span>
                      )}
                      {doc.data_publicacao && (
                        <span className="doc-date">
                          Publicado em:{" "}
                          {new Date(doc.data_publicacao).toLocaleDateString("pt-BR")}
                        </span>
                      )}
                    </div>

                    <h4 className="doc-title">{doc.titulo || doc.nome}</h4>

                    {doc.descricao && (
                      <p className="doc-note">{doc.descricao}</p>
                    )}
                  </div>

                  <div className="doc-action">
                    {temArquivo ? (
                      <a
                        href={doc.link || doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-acessar"
                      >
                        Acessar Arquivo
                      </a>
                    ) : (
                      <span className="badge-pendente">Indisponível</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-search">
            Nenhum documento encontrado para os filtros selecionados.
          </div>
        )}
      </div>
    </div>
  );
}